import React, { Component } from 'react';
import _ from 'lodash';
import cx from 'classnames';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import contentSubtypeActions from '../actions/contentSubtypeActions';
import { contentTypeList } from '../actions/contentTypeActions';
import ContentTypeData from '../types/ContentTypeData';
import ContentSubtypeData from '../types/ContentSubtypeData';
import { videoActions } from '../reducers/videoCreateContentReducers';
import { audioActions } from '../reducers/audioCreateContentReducers';
import { resetVideoModal } from '../../mylibrary/actions/showVideoProgressActions';
import { resetAudioModal } from '../../mylibrary/actions/showAudioProgressActions';

import { WithStyles, createStyles, List, ListItem, ListItemAvatar, Avatar, ListItemText } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { Grid, Card, CardContent, Typography } from '@material-ui/core';
import { MyPATDialog, MyPATLink } from '../../common';
import { getUserType, removeContentId } from '../../../utils';
import { initialNotesData } from '../types/ContentForNotesDefault';

import getDefaultFormData from '../types/ContentFromDataDefault';
import renderSaveButton from '../components/ContentCreate/HeaderTool';

//services
import contentService from '../services/contentService';
import { AUTHORING_CONTENT_TYPES, AUTHORING_QUESTION_CONTENT_TYPES, AUTHORING_TEST_CONTENT_TYPES, CONTENT_SECTION_KEYS, CONTENT_SPECIAL_PURPOSES, PERMISSION_CONTENT_TYPES, TEST_TEMPLATE_TYPES, USER_RIGHTS, praticeTestTypeCode, CONTENT_TYPE, USER_TYPE, PERMISSION_TEST_CONTENT_TYPES, PERMISSION_QUESTION_CONTENT_TYPES, CREATE_CONTENT_INDEXING, PERMISSION_TO_AUTHORING_CONTENT_TYPE_MAP } from '../../../constants/comman';
import ACLService from '../../acl/services/aclService';
import StudyVideoCreate from './ContentCreate/VideoCreate/StudyVideoCreate';
import StudyAudioCreate from './ContentCreate/AudioCreate/StudyAudioCreate';
import { getUsers } from '../../client/ClientServices';
import Select from "react-select";

const styles = (theme: Theme) => createStyles({
	root: {
		'selected': {
			background: 'rgb(255, 255, 255)',
		}
	},
	cardRoot: {
		cursor: 'pointer',
		background: 'rgb(255, 255, 255)',
		border: '1px solid #DCDCDC',
		borderRadius: 4,
		boxShadow: 'none !important',
		height: 145,
		marginTop: 28,
		marginRight: 28,
		'&:hover': {
			borderColor: '#C3DCF9'
		}
	},
	createDialogWrapper1: {
		padding: '6px 0px 0px 30px',
		justifyContent: 'flex-center'
	},
	createDialogWrapper2: {
		padding: '0px 0px 22px 18px',
		justifyContent: 'flex-start'
	},
	contentTitle: {
		fontStyle: 'normal',
		fontWeight: 600,
		fontSize: 16,
		lineHeight: '19px',
		textAlign: 'center',
		color: 'rgb(51, 51, 51)'
	},
	cardContentRoot: {
		...theme.mixins.gutters(),
		paddingTop: theme.spacing.unit * 2,
		paddingBottom: theme.spacing.unit * 2,
		'&:last-child': {
			paddingBottom: theme.spacing.unit * 2,
		},
		textAlign: 'center'
	},
	cardImageWrapper: {
		width: 70,
		height: 86,
		display: 'flex',
		margin: '0px auto',
	},
	cardImage: {
		maxWidth: '90%',
		width: '100%',
		maxHeight: '100%',
		alignSelf: 'center',
	},
	link: {
		textDecoration: 'unset'
	},
	leftSidebarDialog: {
		position: 'sticky',
		top: -16,
		maxHeight: 472,
		overflowY: 'auto',
	},
	selectedListItem: {
		backgroundColor: '#1D7DEA !important',
		height: 55
	},
	listItemHover: {
		cursor: 'pointer',
		padding: 16,
		marginBottom: 12,
		height: 55,
		'&:hover': {
			backgroundColor: 'rgb(240, 247, 255) !important'
		},
		'&:focus': {
			backgroundColor: '#1D7DEA !important'
		}
	},
	sideBar: {
		padding: '0px !important',
		marginLeft: -12,
		borderRight: 'solid 1px rgb(225, 225, 225)',
		position: 'sticky'
	},
	listItemLabel: {
		fontFamily: 'Nunito',
		fontStyle: 'normal',
		fontWeight: 600,
		fontSize: 20,
		lineHeight: '24px',
		color: 'rgb(51, 51, 51)'
	},
	whiteColor: {
		color: '#fff !important'
	},
	noPadding: {
		padding: '0px !important'
	},
	listItem: {
		marginBottom: 12,
		cursor: 'pointer',
		padding: 16,
		height: 52
	},
	heightSM: {
		minHeight: 375,
		maxHeight: 500
	},
	inheritMaxHeight: {
		maxHeight: 'inherit'
	},
	disable: {
		opacity: 0.5,
		pointerEvents: "none"
	},
	disableSubTypes: {
		opacity: 0.5,
		pointerEvents: "none",
		padding: '0px !important'
	},
	customReactSelect: {
		width: '300px',
		marginLeft: '10px',
		'& > div+div > div': {
		  maxHeight: '250px',
		  overflowX: 'hidden',
		  wordBreak: 'break-word',
		},
		textTransform: 'capitalize',
	},
	contentCreatorContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		paddingBottom: '10px',
		borderBottom: '1px solid #E6E6E6',
		fontSize: '14px',
		fontWeight: 500,
		paddingRight: '13px',
	},
	testTemplateTypes: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		gap: '8px',
		position: 'relative',
	},
	testTemplateDescription: {
		color: '#999',
		fontFamily: 'Nunito',
		fontSize: 14,
		fontStyle: 'normal',
		fontWeight: 400,
		lineHeight: '24px',
	},
	templateType: {
		display: 'flex',
		padding: '11px 15px',
		justifyContent: 'center',
		alignItems: 'center',
		color: '#666666',
		cursor: 'pointer',
		background: '#FFFFFF',
		'&:nth-child(1)': {
			borderRadius: '4px 0px 0px 4px',
		},
		'&:nth-child(2)': {
			borderRadius: '0px 4px 4px 0px',
		},
		'&.active': {
			border: '1px solid #1D7DEA',
			background: '#1D7DEA',
			color: '#FFFFFF',
		}
	},
	templateTypeTabs: {
		display: 'flex',
		borderRadius: 4,
		border: '1px solid rgba(153, 153, 153, 0.40)',
		zIndex: 0,
		'&::after': {
			content: '" "',
			border: '1px solid #E6E6E6',
			width: '107%',
			position: 'absolute',
			zIndex: -1,
			left: '-21px',
			top:54,
		}
	},
	center: {
        maxWidth: "350px",
        textAlign: "center",
        margin: 'auto',
    },
    img: {
        width: "60%"
    },
    heading: {
        marginTop: "20px"
    },
});

//@ts-ignore
interface CreateContentModalsProps extends WithStyles<typeof styles> {
	classes: any,
	createContentOpen: boolean,
	createContentCloseHandler: Function,
	contentTypeList: Function,
	contentSubtypeByContentTypeCode: Function,
	contentType: {
		list: ContentTypeData[],
		error: string | null,
	},
	contentSubtype: {
		list: ContentSubtypeData[],
		question: ContentSubtypeData[],
		ftreQuestion: ContentSubtypeData[],
		aitsQuestion: ContentSubtypeData[],
		nationalLevelQuestion: ContentSubtypeData[],
		testpapers: ContentSubtypeData[],
		studymaterial: ContentSubtypeData[],
		practiceSet: ContentSubtypeData[],
		ftreTestpapers: ContentSubtypeData[],
		aitsTestpapers: ContentSubtypeData[],
		nationalLevelTestpapers: ContentSubtypeData[],
		error: string | null
	},
	userData: any,

	resetVideoModalState: Function,
	resetVideoModal: Function,
	resetAudioModalState: Function,
	resetAudioModal: Function,
}

interface CreateContentModalsStates {
	createContentStep2Open: boolean,
	createVideoContentOpen: boolean,
	createAudioContentOpen: boolean,
	selectedContentTypeCode: string,
	contentData: object,
	selectedIndex: number,
	contentCreatorsList: any,
	contentCreator: any,
	testTemplateType: string,
}

const notes: any = {
	_id: 0,
	contentTypeId: {
		code: 'studymaterial',
		name: 'Study Material',
	},
	code: 'notes',
	name: 'Notes',
};

const BASE_URL_QUESTION_TYPE_IMAGES = 'https://d9nag8bjm6x9g.cloudfront.net/webcontent/cms/'

const questionTypeImages: any = {
	"SMCQ": BASE_URL_QUESTION_TYPE_IMAGES + 'Group+(15).png',
	"MMCQ": BASE_URL_QUESTION_TYPE_IMAGES + 'Group+(15).png',
	"True & False": BASE_URL_QUESTION_TYPE_IMAGES + 'True+%26+False2.png',
	"Matrix": BASE_URL_QUESTION_TYPE_IMAGES + 'Matrix2.png',
	"Blanks": BASE_URL_QUESTION_TYPE_IMAGES + 'fill2.png',
	"Descriptive": BASE_URL_QUESTION_TYPE_IMAGES + 'Descr.png',
	"Integer": BASE_URL_QUESTION_TYPE_IMAGES + 'Integer.png',
	"Paragraph": BASE_URL_QUESTION_TYPE_IMAGES + 'para2.png',
	"Numerical": BASE_URL_QUESTION_TYPE_IMAGES + 'numeric.png'
}

const studyMaterialTypeImage: any = {
	"Notes": '/assets/svg/createContent/noun_notes.svg',
	"Formula Sheet": '/assets/svg/createContent/noun_sheet.svg',
	"Videos": '/assets/svg/createContent/noun_video.svg',
	"Sample Problem": '/assets/svg/createContent/noun_notes.svg',
	"Audios":'/assets/svg/createContent/noun_audio.svg'
}

const practiceSetTypeImage: any = {
	"CPP (Subjective)": '/assets/svg/createContent/cppSubjective.svg',
	"CPP (Objective)": '/assets/svg/createContent/cppObjective.svg',
	"Workbook (Subjective)": '/assets/svg/createContent/workbookSubjective.svg',
	"Workbook (Objective)": '/assets/svg/createContent/workbookObjective.svg',
	"Assignment (Subjective)":'/assets/svg/createContent/assignmentSubjective.svg',
	"Assignment (Objective)": '/assets/svg/createContent/assignmentObjective.svg',	
	"Archive (Subjective)": '/assets/svg/createContent/archiveSubjective.svg',
	"Archive (Objective)": '/assets/svg/createContent/archiveObjective.svg',
}
let studyMaterialData: any = [];

const DEFAULT_CREATOR = {
	value: '',
	label: 'Self',
	id: '',
};

class CreateContentModals extends Component<CreateContentModalsProps, CreateContentModalsStates> {

	constructor(props: CreateContentModalsProps) {
		super(props);
		let defaultFromData = null;
		this.createContentStep2OpenHandler = this.createContentStep2OpenHandler.bind(this);
		this.createContentStep2CloseHandler = this.createContentStep2CloseHandler.bind(this);
		if (_.get(this.props, "match.params.type", "") === 'question') {
			defaultFromData = getDefaultFormData(_.get(this.props, "match.params.subType"))
		} else {
			defaultFromData = getDefaultFormData()
		}
		this.state = {
			createVideoContentOpen: false,
			createAudioContentOpen: false,
			createContentStep2Open: false,
			selectedContentTypeCode: "",
			contentData: defaultFromData,
			selectedIndex: 0,
			contentCreatorsList: [],
			contentCreator: {},
			testTemplateType: TEST_TEMPLATE_TYPES.DEFAULT,
		};
	};

	componentDidMount() {
		if (_.isEmpty(this.props.contentType.list)) { this.props.contentTypeList(); }
		const permissionOrder = [PERMISSION_CONTENT_TYPES.STUDY_MATERIAL, ...PERMISSION_QUESTION_CONTENT_TYPES, ...PERMISSION_TEST_CONTENT_TYPES];
		for (let i = 0; i < permissionOrder.length; i++) {
			if (ACLService.checkModulePermission(permissionOrder[i], USER_RIGHTS.CREATE)) {
				this.createContentStep2OpenHandler(PERMISSION_TO_AUTHORING_CONTENT_TYPE_MAP[permissionOrder[i]], CREATE_CONTENT_INDEXING[permissionOrder[i]]);
				break;
			}
		}
		const userData = JSON.parse(localStorage.getItem('patmy') || '');
		const clientId = _.get(userData, 'authenticatedUser.clientId._id', '');
		const userId = _.get(userData, 'authenticatedUser._id', '');
		const userRole = _.get(userData, 'authenticatedUser.role.role', '');
		if (['EDP'].includes(userRole)) {
			getUsers(clientId).then((creators: any) => {
				const users = _.get(creators,'responseObject', []);
				const updatedCreatorsList = [];
				users.forEach((creator: any) => {
					const { firstName, lastName, email, clientId, _id, empCode } = creator;
					if (_id === userId) {
						return;
					}
					const nameToShow = firstName ? `${firstName} ${lastName}` : email;
					const userObj =  {
						id: _id,
						email,
						clientId,
						value: _id,
						label: nameToShow + (empCode ? ` (${empCode})` : ''),
						_id,
					};
					updatedCreatorsList.push(userObj);
				});
				updatedCreatorsList.unshift(DEFAULT_CREATOR);
				this.setState({ contentCreatorsList: updatedCreatorsList, contentCreator: DEFAULT_CREATOR });
			});
		}
		getUserType(USER_TYPE.STUDENT) && this.createContentStep2OpenHandler(CONTENT_TYPE.QUESTION, 2);
	}

	createVideoOpenHandler = () => {
		this.setState({
			createVideoContentOpen: true
		});
	};

	createVideoCloseHandler = () => {
		this.props.resetVideoModalState();
		this.setState({
			createVideoContentOpen: false
		});
	};

	createAudioOpenHandler = () => {
		this.setState({
			createAudioContentOpen: true
		});
	};

	createAudioCloseHandler = () => {
		this.props.resetAudioModalState();
		this.setState({
			createAudioContentOpen: false
		});
	};

	createContentStep2OpenHandler = (code: any, index: number) => {
		this.setState({ selectedContentTypeCode: code, selectedIndex: index, testTemplateType: TEST_TEMPLATE_TYPES.DEFAULT });
		// if (_.isEqual(code, 'studymaterial')) {
		// 	studyMaterialData = _.filter(this.props.contentType.list, ({ code }) =>
		// 		!_.includes(['testpapers', 'question', 'studymaterial'], code));
		// 	//contentService.save('', code, this.state.contentData, false);
		// 	studyMaterialData = [notes, ...studyMaterialData];
		// } else {
		// 	studyMaterialData = [];
		if (AUTHORING_TEST_CONTENT_TYPES.includes(code)) {
			this.props.contentSubtypeByContentTypeCode(code, TEST_TEMPLATE_TYPES.DEFAULT, true);
		} else {
			this.props.contentSubtypeByContentTypeCode(code);
		}
		// }
		this.setState({
			createContentStep2Open: true,
		});

	};

	createContentStep2CloseHandler = () => {
		this.setState({
			createContentStep2Open: false
		});
	};

	getImgUrl(item: any) {
		const sectionLevel: string = item.sectionLevel;
		const name: string = item.name;
		if (item.code === 'unit') {
			return '/assets/img/mylibrary/contentSubtype/unit-test.svg';
		}
		switch (sectionLevel) {
			case 'Subject':
				if (questionTypeImages.hasOwnProperty(name)) {
					return questionTypeImages[name];
				}
				if (practiceSetTypeImage.hasOwnProperty(name)) {
					return practiceSetTypeImage[name];
				}
				if (studyMaterialTypeImage.hasOwnProperty(name)) {
					return studyMaterialTypeImage[name];
				}
				return '/assets/img/mylibrary/contentSubtype/full.png';
				

			case 'Chapter':
				return '/assets/img/mylibrary/contentSubtype/chap.png'

			default:
				if (studyMaterialTypeImage.hasOwnProperty(name)) {
					return studyMaterialTypeImage[name];
				}
				return '/assets/svg/createContent/noun_notes.svg'
		}
	}
	checkSubDialogPermissions = (code: string) => {
		const { classes } = this.props;
		switch (code) {
			case 'studymaterial':
				return !ACLService.checkModulePermission("studymaterial", "create") ? classes.disableSubTypes : classes.noPadding
			default:
				return classes.noPadding
		}

	}

	handleContentCreatorChange = (creator: any) => {
		this.setState({
			contentCreator: creator,
		});
	};

	handleModalClose = () => {
		this.setState({ contentCreator: DEFAULT_CREATOR });
		this.props.createContentCloseHandler();
	}

	changeTemplateType = (type: string) => {
		this.setState({ testTemplateType: type },() => {
			const {selectedContentTypeCode, testTemplateType} = this.state;
			this.props.contentSubtypeByContentTypeCode(selectedContentTypeCode, testTemplateType, true);
		});
	}

	render() {
		const { classes, createContentOpen, createContentCloseHandler, contentSubtype } = this.props;
		const { createContentStep2Open, selectedContentTypeCode, selectedIndex, createVideoContentOpen, createAudioContentOpen, contentCreatorsList, contentCreator, testTemplateType } = this.state;
		const otherDialogProps = {
			fullWidth: true,
			maxWidth: 'md',
			scroll: 'body',
		};
		let contentStep2Heading = '';

		let contentSubtypeDialogData = _.isEmpty(studyMaterialData) ? contentSubtype.list : studyMaterialData;

		if (selectedContentTypeCode == "studymaterial") {
			contentSubtypeDialogData = contentSubtype.studymaterial;
			contentStep2Heading = "Select "
			// + contentSubtypeDialogData[0].contentTypeId.name;
		} else if (selectedContentTypeCode == "question") {
			contentSubtypeDialogData = contentSubtype.question;
			if (contentSubtypeDialogData[0]) {
				contentStep2Heading = "Select " + contentSubtypeDialogData[0].contentTypeId.name;
			}
		}  else if (selectedContentTypeCode == "practiceSet") {
			contentSubtypeDialogData = contentSubtype.practiceSet;
			if (contentSubtypeDialogData[0]) {
				contentStep2Heading = "Select " + contentSubtypeDialogData[0].contentTypeId.name;
			}
		} else if (selectedContentTypeCode == "ftreQuestion") {
			contentSubtypeDialogData = contentSubtype.ftreQuestion;
			if (contentSubtypeDialogData[0]) {
				contentStep2Heading = "Select " + contentSubtypeDialogData[0].contentTypeId.name;
			}
		} else if (selectedContentTypeCode === AUTHORING_CONTENT_TYPES.FTRE_TESTPAPERS) {
			contentSubtypeDialogData = contentSubtype.ftreTestpapers;
		} else if (selectedContentTypeCode === AUTHORING_CONTENT_TYPES.AITS_QUESTION) {
			contentSubtypeDialogData = contentSubtype.aitsQuestion;
		} else if (selectedContentTypeCode === AUTHORING_CONTENT_TYPES.AITS_TESTPAPERS) {
			contentSubtypeDialogData = contentSubtype.aitsTestpapers;
		} else if (selectedContentTypeCode === AUTHORING_CONTENT_TYPES.NATIONAL_LEVEL_QUESTION) {
			contentSubtypeDialogData = contentSubtype.nationalLevelQuestion;
		} else if (selectedContentTypeCode === AUTHORING_CONTENT_TYPES.NATIONAL_LEVEL_TESTPAPERS) {
			contentSubtypeDialogData = contentSubtype.nationalLevelTestpapers;
		} else {
			contentSubtypeDialogData = contentSubtype.testpapers;
			if (contentSubtypeDialogData.length > 0) {
				contentSubtypeDialogData = contentSubtypeDialogData.filter((element: any) => element.code != praticeTestTypeCode);
			}
			contentStep2Heading = "Select Test Type";
		}
		const studentUser = getUserType(USER_TYPE.STUDENT);
		return (
			<>
				{
					createVideoContentOpen && !createContentOpen &&
					<StudyVideoCreate dialogOpen={createVideoContentOpen && !createContentOpen} onDialogClose={this.createVideoCloseHandler} />
				}
				{
					createAudioContentOpen && !createContentOpen &&
					<StudyAudioCreate dialogOpen={createAudioContentOpen && !createContentOpen} onDialogClose={this.createAudioCloseHandler} />
				}
				<MyPATDialog
					dialogHeading={studentUser ? 'Create question' : 'Get Started With Authoring'}
					dialogOpen={createContentOpen}
					otherDialogProps={otherDialogProps}
					dialogHasActions={false}
					customButtonVariant="withoutBorderCloseIcon"
					onDialogClose={this.handleModalClose}
					isAlignCenter={true}
					stopParentScroll={true}
					dialogCustomClasses={studentUser && classes.inheritMaxHeight}
				>
					<Grid container spacing={32} justify="space-around" className={cx(classes.heightSM, { [classes.inheritMaxHeight]: studentUser })}>
						{!studentUser && <Grid item sm={4} className={classes.sideBar}>
							<List className={classes.leftSidebarDialog}>
								{ ACLService.checkModulePermission(PERMISSION_CONTENT_TYPES.STUDY_MATERIAL, USER_RIGHTS.CREATE) &&
								<ListItem
									selected={selectedIndex === 0}
									classes={{ selected: classes.selectedListItem, root: (selectedIndex != 0 ? classes.listItemHover : classes.listItem) }}
									className={!ACLService.checkModulePermission("studyMaterial", "create") ? classes.disable : ""}
									onClick={this.createContentStep2OpenHandler.bind(this, 'studymaterial', 0)}>
									<ListItemAvatar>
										<img
											alt="Study Material"
											src={(selectedIndex === 0) ? "/assets/svg/createContent/whiteBook.svg" : "/assets/svg/createContent/studyMaterial.svg"}
										/>
									</ListItemAvatar>
									<ListItemText classes={{ primary: [classes.listItemLabel, ((selectedIndex === 0) ? classes.whiteColor : '')].join(' ') }} primary="Create Study Material" />
								</ListItem>
								}
								{ACLService.checkModulePermission(PERMISSION_CONTENT_TYPES.STUDY_MATERIAL, USER_RIGHTS.CREATE) &&
								<ListItem
									selected={selectedIndex === 3}
									classes={{ selected: classes.selectedListItem, root: (selectedIndex !== 3 ? classes.listItemHover : classes.listItem) }}
									className={!ACLService.checkModulePermission("studyMaterial", "create") ? classes.disable : ""}
									onClick={this.createContentStep2OpenHandler.bind(this, 'practiceSet', 3)}>
									<ListItemAvatar>
										<img
											alt="Practice Set"
											src={(selectedIndex === 3) ? "/assets/svg/createContent/whitePracticeTest.svg" : "/assets/svg/createContent/practiceTest.svg"}
										/>
									</ListItemAvatar>
									<ListItemText classes={{ primary: [classes.listItemLabel, ((selectedIndex === 3) ? classes.whiteColor : '')].join(' ') }} primary="Create Practice Set" />
								</ListItem>
								}
								{ACLService.checkModulePermission(PERMISSION_CONTENT_TYPES.GLORIFIRE_QUESTION, USER_RIGHTS.CREATE) && (
								<ListItem
									selected={selectedIndex === 2}
									classes={{ selected: classes.selectedListItem, root: (selectedIndex !== 2 ? classes.listItemHover : classes.listItem) }}
									className={!ACLService.checkModulePermission("question", "create") ? classes.disable : ""}
									onClick={this.createContentStep2OpenHandler.bind(this, 'question', 2)}>
									<ListItemAvatar>
										<img
											alt="Study Material"
											src={(selectedIndex === 2) ? "/assets/svg/createContent/whiteQuestions.svg" : "/assets/svg/createContent/questions.svg"}
										/>
									</ListItemAvatar>
									<ListItemText classes={{ primary: [classes.listItemLabel, ((selectedIndex === 2) ? classes.whiteColor : '')].join(' ') }} primary="Create Question (Glorifire)" />
								</ListItem>
								)}
								{ACLService.checkModulePermission(PERMISSION_CONTENT_TYPES.FTRE_QUESTION, USER_RIGHTS.CREATE) && (
								<ListItem
									selected={selectedIndex === 4}
									classes={{ selected: classes.selectedListItem, root: (selectedIndex !== 4 ? classes.listItemHover : classes.listItem) }}
									className={!ACLService.checkModulePermission(PERMISSION_CONTENT_TYPES.FTRE_QUESTION, "create") ? classes.disable : ""}
									onClick={this.createContentStep2OpenHandler.bind(this, AUTHORING_CONTENT_TYPES.FTRE_QUESTION, 4)}>
									<ListItemAvatar>
										<img
											alt="FTRE Question"
											src={(selectedIndex === 4) ? "/assets/svg/createContent/whiteFtreQuestion.svg" : "/assets/svg/createContent/ftreQuestion.svg"}
										/>
									</ListItemAvatar>
									<ListItemText classes={{ primary: [classes.listItemLabel, ((selectedIndex === 4) ? classes.whiteColor : '')].join(' ') }} primary="Create Question (Admission Test)" />
								</ListItem>
								)}
								{ACLService.checkModulePermission(PERMISSION_CONTENT_TYPES.AITS_QUESTION, USER_RIGHTS.CREATE) && (
								<ListItem
									selected={selectedIndex === 5}
									classes={{ selected: classes.selectedListItem, root: (selectedIndex !== 5 ? classes.listItemHover : classes.listItem) }}
									onClick={this.createContentStep2OpenHandler.bind(this, 'aitsQuestion', 5)}>
									<ListItemAvatar>
										<img
											alt="AITS Question"
											src="/assets/svg/createContent/aits-question.svg"
										/>
									</ListItemAvatar>
									<ListItemText classes={{ primary: [classes.listItemLabel, ((selectedIndex === 5) ? classes.whiteColor : '')].join(' ') }} primary="Create Question (AITS)" />
								</ListItem>
								)}
								{ACLService.checkModulePermission(PERMISSION_CONTENT_TYPES.NATIONAL_LEVEL_QUESTION, USER_RIGHTS.CREATE) && (
								<ListItem
									selected={selectedIndex === 6}
									classes={{ selected: classes.selectedListItem, root: (selectedIndex !== 6 ? classes.listItemHover : classes.listItem) }}
									onClick={this.createContentStep2OpenHandler.bind(this, 'nationalLevelQuestion', 6)}>
									<ListItemAvatar>
										<img
											alt="National Level Question"
											src="/assets/svg/createContent/national-level-question.svg"
										/>
									</ListItemAvatar>
									<ListItemText classes={{ primary: [classes.listItemLabel, ((selectedIndex === 6) ? classes.whiteColor : '')].join(' ') }} primary="Create Question (National Level Test)" />
								</ListItem>
								)}
								{ACLService.checkModulePermission(PERMISSION_CONTENT_TYPES.GLORIFIRE_TESTPAPERS, USER_RIGHTS.CREATE) && (
								<ListItem
									selected={selectedIndex === 1}
									classes={{ selected: classes.selectedListItem, root: (selectedIndex !== 1 ? classes.listItemHover : classes.listItem) }}
									className={!ACLService.checkModulePermission("test", "create") ? classes.disable : ""}
									onClick={this.createContentStep2OpenHandler.bind(this, 'testpapers', 1)}>
									<ListItemAvatar>
										<img
											alt="Study Material"
											src={(selectedIndex === 1) ? "/assets/svg/createContent/whiteTest.svg" : "/assets/svg/createContent/test.svg"}
										/>
									</ListItemAvatar>
									<ListItemText classes={{ primary: [classes.listItemLabel, ((selectedIndex === 1) ? classes.whiteColor : '')].join(' ') }} primary="Create Test (Glorifire)" />
								</ListItem>
								)}
								{ACLService.checkModulePermission(PERMISSION_CONTENT_TYPES.FTRE_TESTPAPERS, USER_RIGHTS.CREATE) && (
								<ListItem
									selected={selectedIndex === 7}
									classes={{ selected: classes.selectedListItem, root: (selectedIndex !== 7 ? classes.listItemHover : classes.listItem) }}
									onClick={this.createContentStep2OpenHandler.bind(this, 'ftreTestpapers', 7)}>
									<ListItemAvatar>
										<img alt="FTRE Test" src="/assets/svg/createContent/ftre-test.svg" />
									</ListItemAvatar>
									<ListItemText classes={{ primary: [classes.listItemLabel, ((selectedIndex === 7) ? classes.whiteColor : '')].join(' ') }} primary="Create Test (Admission Test)" />
								</ListItem>
								)}
								{ACLService.checkModulePermission(PERMISSION_CONTENT_TYPES.AITS_TESTPAPERS, USER_RIGHTS.CREATE) && (
								<ListItem
									selected={selectedIndex === 8}
									classes={{ selected: classes.selectedListItem, root: (selectedIndex !== 8 ? classes.listItemHover : classes.listItem) }}
									onClick={this.createContentStep2OpenHandler.bind(this, 'aitsTestpapers', 8)}>
									<ListItemAvatar>
										<img alt="AITS Test" src="/assets/svg/createContent/aits-test.svg" />
									</ListItemAvatar>
									<ListItemText classes={{ primary: [classes.listItemLabel, ((selectedIndex === 8) ? classes.whiteColor : '')].join(' ') }} primary="Create Test (AITS)" />
								</ListItem>
								)}
								{ACLService.checkModulePermission(PERMISSION_CONTENT_TYPES.NATIONAL_LEVEL_TESTPAPERS, USER_RIGHTS.CREATE) && (
								<ListItem
									selected={selectedIndex === 9}
									classes={{ selected: classes.selectedListItem, root: (selectedIndex !== 9 ? classes.listItemHover : classes.listItem) }}
									onClick={this.createContentStep2OpenHandler.bind(this, AUTHORING_CONTENT_TYPES.NATIONAL_LEVEL_TESTPAPERS, 9)}>
									<ListItemAvatar>
										<img alt="National Levl Test" src="/assets/svg/createContent/national-level-test.svg" />
									</ListItemAvatar>
									<ListItemText classes={{ primary: [classes.listItemLabel, ((selectedIndex === 9) ? classes.whiteColor : '')].join(' ') }} primary="Create Test (National Level Test)" />
								</ListItem>
								)}
							</List>
						</Grid>
						}<Grid item sm={studentUser ? 12 : 8}>
							{
								contentCreatorsList && contentCreatorsList.length ?
								<div className={classes.contentCreatorContainer}>
									Select Content Creator
									<Select
										value={contentCreator || null}
										onChange={this.handleContentCreatorChange}
										options={contentCreatorsList}
										className={classes.customReactSelect}
										blurInputOnSelect={true}
									/>
								</div>
								:
								<></>
							}
							{
								AUTHORING_TEST_CONTENT_TYPES.includes(selectedContentTypeCode) && (
									<div className={classes.testTemplateTypes}>
										<span className={classes.testTemplateDescription}>Select Test Type:</span>
										<div className={classes.templateTypeTabs}>
											<span className={cx(classes.templateType, { 'active': testTemplateType === TEST_TEMPLATE_TYPES.DEFAULT })} onClick={() => this.changeTemplateType(TEST_TEMPLATE_TYPES.DEFAULT)} >Default</span>
											<span className={cx(classes.templateType, { 'active': testTemplateType === TEST_TEMPLATE_TYPES.CUSTOM })} onClick={() => this.changeTemplateType(TEST_TEMPLATE_TYPES.CUSTOM)} >Custom</span>
										</div>
									</div>)
							}
							{!_.isEmpty(contentSubtypeDialogData) && (
								<>
								<Grid container
									spacing={(contentSubtypeDialogData.length > 6) ? 16 : 32}
									justify="space-around"
									className={cx({ [classes.createDialogWrapper1]: selectedContentTypeCode === "studymaterial", [classes.createDialogWrapper2]: selectedContentTypeCode !== "studymaterial" })}
								>
									{
										contentSubtypeDialogData.map((item: any) => (
											<Grid item
												sm={studentUser ? 4 : 6}
												key={item._id}
												className={this.checkSubDialogPermissions(selectedContentTypeCode)}
											>
												{/* <a
												href={`/content/create/${contentSubtypeDialogData[0].contentTypeId.code}/${item.code}`} className={classes.link}
												target={"_blank"}
												onClick={()=> removeContentId()}
											> Just for the reusability */}
												<a className={classes.link}
													// href="#"
													onClick={() => {

														let defaultFromData: any = null;
														localStorage.setItem('passageData', '');
														let contentTypeCode = contentSubtypeDialogData[0].contentTypeId.code;
														if (AUTHORING_QUESTION_CONTENT_TYPES.includes(contentSubtypeDialogData[0].contentTypeId.code)) {
															defaultFromData = getDefaultFormData(item.code)
														} else {
															defaultFromData = getDefaultFormData()
														}
														if (contentSubtypeDialogData[0].contentTypeId.code == "testpapers") {
															defaultFromData.settings ={...defaultFromData.settings,...item,testType:item.code,duration:item.time};
															defaultFromData.testTemplateTypeId=item._id;
														}
														if (contentSubtypeDialogData[0].contentTypeId.code == AUTHORING_CONTENT_TYPES.FTRE_TESTPAPERS) {
															defaultFromData.settings = { ...defaultFromData.settings, ...item, testType: item.code, duration: item.time };
															defaultFromData.testTemplateTypeId = item._id;
															defaultFromData.specialPurposes = [CONTENT_SPECIAL_PURPOSES.FTRE];
															contentTypeCode = AUTHORING_CONTENT_TYPES.GLORIFIRE_TESTPAPERS;
														}
														if ([AUTHORING_CONTENT_TYPES.AITS_TESTPAPERS, AUTHORING_CONTENT_TYPES.NATIONAL_LEVEL_TESTPAPERS].includes(contentSubtypeDialogData[0].contentTypeId.code)) {
															defaultFromData.settings = { ...defaultFromData.settings, ...item, testType: item.code, duration: item.time };
															defaultFromData.testTemplateTypeId = item._id;
															contentTypeCode = AUTHORING_CONTENT_TYPES.GLORIFIRE_TESTPAPERS;
															if(contentSubtypeDialogData[0].contentTypeId.code === AUTHORING_CONTENT_TYPES.AITS_TESTPAPERS) {
																defaultFromData.specialPurposes = [CONTENT_SECTION_KEYS.AITS];
															} else {
																defaultFromData.specialPurposes = [CONTENT_SECTION_KEYS.NATIONAL_LEVEL_TEST];
															}
														}
														if (AUTHORING_QUESTION_CONTENT_TYPES.includes(contentSubtypeDialogData[0].contentTypeId.code)) {
															defaultFromData.questionCode = parseInt(item.code)
															const contentKey = contentSubtypeDialogData[0].contentTypeId.code;
															_.get(this.props.contentSubtype, contentKey, []).forEach((st: any) => {
																if (item.code == parseInt(st.code)) {
																	defaultFromData.questionType = st.name;
																}
															});
															if (contentKey === AUTHORING_CONTENT_TYPES.FTRE_QUESTION) {
																defaultFromData.specialPurposes = [CONTENT_SECTION_KEYS.FTRE];
															} else if (contentKey === AUTHORING_CONTENT_TYPES.AITS_QUESTION) {
																defaultFromData.specialPurposes = [CONTENT_SECTION_KEYS.AITS];
															} else if(contentKey === AUTHORING_CONTENT_TYPES.NATIONAL_LEVEL_QUESTION) {
																defaultFromData.specialPurposes = [CONTENT_SECTION_KEYS.NATIONAL_LEVEL_TEST];
															}
															contentTypeCode = AUTHORING_CONTENT_TYPES.GLORIFIRE_QUESTION;
														}
														if (contentSubtypeDialogData[0].contentTypeId.code == "studymaterial" && item.code != "notes") {
															contentTypeCode = item.code;
														}

														if (contentCreator.id) {
															defaultFromData.createdFor = contentCreator;
															initialNotesData.createdFor = contentCreator;
														}
														if (item.code === 'note' && contentSubtypeDialogData[0].contentTypeId.code !== 'practiceSet') {
															contentService.save('', 'note', initialNotesData, false)
																.then((res: any) => {
																	window.open(
																		`content/edit/${contentSubtypeDialogData[0].contentTypeId.code}/notes
															/${res.responseObject.note._id}${item.code}`, "_blank");
																})// if change this route please check the below route too 

														}
														else if (contentSubtypeDialogData[0].contentTypeId.code === 'practiceSet') {

															const notesPayload = { ...initialNotesData };

															notesPayload.subType = item.code;
															notesPayload.title = item.name;

															contentService.save('', 'note', notesPayload, false)
																.then((res: any) => {
																	window.open(
																		`content/edit/studymaterial/notes
															/${res.responseObject.note._id}note`, "_blank");
																});
														}
														else if ([...AUTHORING_QUESTION_CONTENT_TYPES, ...AUTHORING_TEST_CONTENT_TYPES].includes(contentSubtypeDialogData[0].contentTypeId.code)) {

															contentService.save('', contentTypeCode, defaultFromData, false)
																.then((res: any) => {
																	window.open(
																		`content/edit/${contentTypeCode}/${item.code}
																/${res.responseObject._id}${contentTypeCode}`, "_blank");
																})
														}
														else if (item.code === 'videos' && !createVideoContentOpen) {
															createContentCloseHandler();
															this.createVideoOpenHandler();
														} 
														else if (item.code === 'audios' && !createAudioContentOpen) {
															createContentCloseHandler();
															this.createAudioOpenHandler();
														} else {
															contentService.save('', contentTypeCode, defaultFromData, false)
																.then((res: any) => {
																	window.open(
																		`content/edit/${contentSubtypeDialogData[0].contentTypeId.code}/${item.code}
																/${res.responseObject._id}${contentTypeCode}`, "_blank");
																})
														}
													}}
													
												>
													<Card className={classes.cardRoot}>
														<CardContent className={classes.cardContentRoot}>
															<div className={classes.cardImageWrapper}>
																<img
																	alt={item.name}
																	src={this.getImgUrl(item)}
																	className={classes.cardImage}
																/>
															</div>
															<Typography variant="h5" className={classes.contentTitle}>{item.name}</Typography>
														</CardContent>
													</Card>
												</a>
											</Grid>
										))
									}
								</Grid>
								</>
							)}
							{!(contentSubtypeDialogData && contentSubtypeDialogData.length) && AUTHORING_TEST_CONTENT_TYPES.includes(selectedContentTypeCode) &&
								(
									<div className={classes.center}>
										<img alt="no content" className={classes.img} src='/assets/img/mylibrary/no-content.png' />
										<Typography variant="h6" className={classes.heading} gutterBottom>Oh Snap! We can't find it</Typography>
										<Typography variant="caption" color="textSecondary" gutterBottom>Currently there are no templates created for the selected type</Typography>
									</div>
								)
							}
						</Grid>
					</Grid>
				</MyPATDialog>
			</>
		)
	}
};

const mapStateToProps = (state: any) => ({
	contentType: _.get(state, 'mylibraryData.contentType', {}),
	contentSubtype: _.get(state, 'mylibraryData.contentSubtype', {}),
	userData: state.loginData.userData
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
	contentSubtypeByContentTypeCode: contentSubtypeActions.contentSubtypeByContentTypeCode,
	contentTypeList,
	resetVideoModal,
	resetAudioModal,
	resetVideoModalState: videoActions.resetVideoModalState,
	resetAudioModalState: audioActions.resetAudioModalState,
}, dispatch);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CreateContentModals));